/*
 * /document-writer — интерфейс прибора.
 *
 * Строка инструментов, меню, поиск, структура, статистика, шаблоны, вид и
 * масштаб, «Мои документы», файлы. Действия — одна таблица `act()`: кнопка на
 * строке, тот же пункт в «Ещё», плавающая панель над выделением и горячая
 * клавиша зовут одно и то же.
 */
(function () {
'use strict';
var DW = window.DW;
if (!DW) return;
var C = DW.C, S = DW.S, doc = DW.doc, $ = DW.$, t = DW.t, esc = DW.esc;
var root = DW.root, canvas = $('dwCanvas'), paper = $('dwPaper'), bar = $('dwBar');
var lgRoot = $('dwRoot');
var SLUG = 'document-writer';
var prefs = window.__toolSettings || { save: function () {}, load: function (a, b, fb) { return fb; } };

/* ── полезное ──────────────────────────────────────────────────────────── */
function stage(n) { try { if (window.__stage) window.__stage(n); } catch (e) {} }
function closePops() {
    lgRoot.querySelectorAll('.dw-pop').forEach(function (p) {
        try { if (window.__anchoredPopover) window.__anchoredPopover.close(p); else if (p.hidePopover) p.hidePopover(); } catch (e) {}
    });
}
function openPop(id, anchor) {
    var p = $(id); if (!p) return;
    try {
        if (window.__anchoredPopover && anchor) window.__anchoredPopover.anchorTo(p, anchor);
        if (p.showPopover) { if (!p.matches(':popover-open')) p.showPopover(); }
        else { p.setAttribute('data-pop-open', 'true'); }
        if (window.__anchoredPopover && anchor) window.__anchoredPopover.place && window.__anchoredPopover.place(p, anchor);
    } catch (e) { DW.report(e, 'pop_open'); }
}
function dlg(id) {
    var d = $(id); if (!d) return null;
    try { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); } catch (e) { d.setAttribute('open', ''); }
    return d;
}
lgRoot.addEventListener('click', function (e) {
    var x = e.target.closest('[data-close]');
    if (!x) return;
    var d = x.closest('dialog');
    if (d) { try { d.close(); } catch (er) { d.removeAttribute('open'); } }
});
lgRoot.querySelectorAll('dialog.dw-dlg').forEach(function (d) {
    // щелчок по затемнению закрывает окно
    d.addEventListener('click', function (e) { if (e.target === d) { try { d.close(); } catch (er) {} } });
});
/* Прокрутка ВНУТРИ листа к диапазону — страница сайта не двигается. */
function reveal(target) {
    var r = target.getBoundingClientRect ? target.getBoundingClientRect() : null;
    if (!r) return;
    var cr = canvas.getBoundingClientRect();
    var pad = 60;
    if (r.top < cr.top + pad) canvas.scrollTop -= (cr.top + pad - r.top);
    else if (r.bottom > cr.bottom - pad) canvas.scrollTop += (r.bottom - cr.bottom + pad);
    if (r.left < cr.left) canvas.scrollLeft -= (cr.left - r.left + 20);
    else if (r.right > cr.right) canvas.scrollLeft += (r.right - cr.right + 20);
}
/* Каретка ушла за край области при наборе — подтянуть область (только внутри). */
function keepCaretVisible() {
    var r = DW.sel.range(); if (!r) return;
    var rs = r.getClientRects(), rr = rs.length ? rs[rs.length - 1] : null;
    if (!rr || (!rr.top && !rr.height)) return;
    reveal(rr);
}

/* ── действия ──────────────────────────────────────────────────────────── */
function act(a, v, src) {
    switch (a) {
        case 'undo': DW.history.undo(); break;
        case 'redo': DW.history.redo(); break;
        case 'bold': DW.cmd.run(function () { DW.cmd.exec('bold'); }, 'bold'); break;
        case 'italic': DW.cmd.run(function () { DW.cmd.exec('italic'); }, 'italic'); break;
        case 'underline': DW.cmd.run(function () { DW.cmd.exec('underline'); }, 'underline'); break;
        case 'strike': DW.cmd.run(function () { DW.cmd.exec('strikeThrough'); }, 'strike'); break;
        case 'sup': DW.cmd.run(function () { DW.cmd.exec('superscript'); }, 'sup'); break;
        case 'clear': DW.cmd.run(function () { DW.cmd.exec('removeFormat'); DW.cmd.exec('unlink'); }, 'clear'); break;
        case 'style': DW.cmd.style(v); break;
        case 'font': DW.cmd.font(v); break;
        case 'size': DW.cmd.size(parseFloat(v)); break;
        case 'size-up': DW.cmd.stepSize(1); break;
        case 'size-down': DW.cmd.stepSize(-1); break;
        case 'color': setColor(v); break;
        case 'mark': setMark(v); break;
        case 'align': DW.cmd.align(v); break;
        case 'ul': DW.cmd.list(false); break;
        case 'ol': DW.cmd.list(true); break;
        case 'indent': DW.cmd.indent(1); break;
        case 'outdent': DW.cmd.indent(-1); break;
        case 'lh': docSetting('lh', parseFloat(v)); break;
        case 'pafter': docSetting('pafter', parseFloat(v)); break;
        case 'findent': docSetting('findent', parseFloat(v)); break;
        case 'link': openLink(src); break;
        case 'image': $('dwImgIn').click(); break;
        case 'pagebreak': DW.cmd.pageBreak(); break;
        case 'hr': DW.cmd.hr(); break;
        case 'quote': DW.cmd.style('quote'); break;
        case 'date': DW.cmd.date(); break;
        case 'toc': insertToc(); break;
        case 'symbol': break;
        case 'row-above': case 'row-below': case 'col-left': case 'col-right':
        case 'row-del': case 'col-del': case 'head-toggle': case 'table-del': tableOp(a); break;
        case 'find': openFind(); break;
        case 'escape': if (!$('dwFind').hidden) closeFind(); else if (S.focusOn) setFocus(false); break;
        case 'ai': openAi(); break;
        case 'voice': var vb = $('dwVoiceBtn'); if (vb) vb.click(); break;
        case 'templates': openTemplates(); break;
        case 'open': openPicker(); break;
        case 'save': saveFile(false); break;
        case 'save-as': saveFile(true); break;
        case 'print': printDoc(); break;
        case 'preview': preview(); break;
        case 'share': shareFile(); break;
        case 'dl-docx': download('docx'); break;
        case 'dl-pdf': download('pdf'); break;
        case 'dl-txt': download('txt'); break;
        case 'dl-md': download('md'); break;
        case 'dl-html': download('html'); break;
        case 'typograph': var n = DW.typograph(); DW.toast(n ? t('typograph_done', { n: n }) : t('typograph_none'), n ? 'success' : 'info', n ? undoToastOpts() : undefined); DW.track('typograph', { n: n }); break;
        case 'outline': toggleOutline(); break;
        case 'stats': openStats(); break;
        case 'keys': openKeys(); break;
        case 'autotypo': S.autoTypo = !S.autoTypo; prefs.save(SLUG, 'autotypo', S.autoTypo); syncChecks(); break;
        case 'dark-paper': S.darkPaper = !S.darkPaper; root.setAttribute('data-dark-paper', S.darkPaper ? 'true' : 'false'); prefs.save(SLUG, 'darkpaper', S.darkPaper); syncChecks(); break;
        case 'focus': setFocus(!S.focusOn); break;
        case 'zoom-in': setZoom(Math.min(3, Math.round((S.zoom + 0.1) * 10) / 10), 'fixed'); break;
        case 'zoom-out': setZoom(Math.max(0.3, Math.round((S.zoom - 0.1) * 10) / 10), 'fixed'); break;
        case 'zoom': setZoom(parseFloat(v) / 100, 'fixed'); break;
        case 'zoom-fit': setZoom(fitZoom(), 'fit'); break;
        case 'new': if (DW.drafts) DW.drafts.reset(); else freshDoc(); break;
    }
    if (a !== 'find' && a !== 'escape') syncToolbar();
}
function undoToastOpts() {
    return { action: { label: t('undo'), onclick: function () { DW.history.undo(); } } };
}
function docSetting(k, v) {
    DW.cmd.run(function () { S.set[k] = v; DW.applySettings(); }, 'set_' + k);
    syncSpacing();
}

/* Кнопки внутри прибора не забирают фокус у листа — выделение остаётся, и
   команда ложится на него (поля ввода — исключение, им фокус нужен). */
function keepFocus(e) {
    var b = e.target.closest('button,[data-act]');
    if (!b) return;
    if (b.closest('dialog')) return;
    if (e.target.closest('input,select,textarea,label')) return;
    if (document.activeElement === doc || (DW.sel.last() && doc.contains(DW.sel.last().commonAncestorContainer))) e.preventDefault();
}
lgRoot.addEventListener('mousedown', keepFocus);
lgRoot.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch' || e.pointerType === 'pen') keepFocus(e); });
lgRoot.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b || !lgRoot.contains(b) || b.disabled) return;
    if (b.closest('#dwAiActs')) return;   // у окна ИИ свои кнопки
    act(b.getAttribute('data-act'), b.getAttribute('data-v'), b);
});

/* ── строка инструментов: что не влезло — в «Ещё» ──────────────────────── */
var groups = Array.prototype.slice.call(bar.querySelectorAll('.dw-g[data-g]'));
/* Ширины меряются при КАЖДОМ пересчёте: кнопка диктовки появляется позже (её
   открывает общий примитив, если браузер распознаёт речь), шрифт интерфейса
   догружается — запомненная однажды ширина врала. Показ и скрытие групп
   внутри строки не меняют ширину самой строки, петли с ResizeObserver нет. */
function measureGroups() {
    groups.forEach(function (g) { g.setAttribute('data-over', 'false'); });
    var w = {};
    groups.forEach(function (g) {
        var cs = window.getComputedStyle(g, '::before');
        var sep = cs && cs.content && cs.content !== 'none' ? 9 : 0;
        w[g.getAttribute('data-g')] = g.getBoundingClientRect().width + sep;
    });
    return w;
}
function fitBar() {
    if (!bar.clientWidth) return;
    var widths = measureGroups();
    var avail = $('dwBarS').clientWidth - 4;
    // телефон: лента прокручивается, ничего не сворачиваем
    if (root.offsetWidth < 600) avail = 1e9;
    var order = groups.slice().sort(function (a, b) { return (+a.getAttribute('data-prio')) - (+b.getAttribute('data-prio')); });
    var used = 0, over = {};
    order.forEach(function (g) {
        var id = g.getAttribute('data-g'), w = widths[id] || 0;
        if (used + w <= avail) used += w; else over[id] = 1;
    });
    groups.forEach(function (g) { g.setAttribute('data-over', over[g.getAttribute('data-g')] ? 'true' : 'false'); });
    // разделы «Ещё»
    var more = $('dwPopMore');
    more.querySelectorAll('[data-for]').forEach(function (el) {
        var ids = el.getAttribute('data-for').split(' ');
        el.hidden = !ids.some(function (id) { return over[id]; });
    });
    var narrowTop = root.querySelector('#dwTplBtn').offsetParent === null;
    more.querySelectorAll('.dw-only-sm').forEach(function (el) { el.hidden = !narrowTop; });
    var vmi = more.querySelector('[data-voice-mi]');
    if (vmi && $('dwVoiceBtn').hidden) vmi.hidden = true;
}
if (window.MutationObserver) new MutationObserver(function () { requestAnimationFrame(fitBar); }).observe($('dwVoiceBtn'), { attributes: true, attributeFilter: ['hidden'] });
var roBar = window.ResizeObserver ? new ResizeObserver(function () { requestAnimationFrame(fitBar); }) : null;
if (roBar) roBar.observe(bar); else window.addEventListener('resize', fitBar);

/* ── синхронизация строки с документом ─────────────────────────────────── */
var ALIGN_ICON = {};
['left', 'center', 'right', 'justify'].forEach(function (k) {
    var b = $('dwPopAlign').querySelector('[data-v="' + k + '"]');
    if (b) ALIGN_ICON[k] = b.innerHTML;
});
var syncRaf = 0;
function syncToolbar() {
    if (syncRaf) return;
    syncRaf = requestAnimationFrame(function () {
        syncRaf = 0;
        var f = DW.currentFormat();
        lgRoot.querySelectorAll('[data-state]').forEach(function (b) {
            var st = b.getAttribute('data-state');
            var on = st === 'insertUnorderedList' ? f.inList === 'ul' : st === 'insertOrderedList' ? f.inList === 'ol' : DW.qState(st);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        $('dwStyleName').textContent = t('st_' + f.style);
        var fo = DW.FONTS[f.font];
        $('dwFontName').textContent = fo ? fo.name : '';
        var sz = $('dwSize');
        if (document.activeElement !== sz) sz.value = String(f.size).replace('.', C.locale === 'en' || C.locale === 'ko' ? '.' : ',');
        var ab = $('dwAlignBtn');
        if (ALIGN_ICON[f.align] && ab.getAttribute('data-cur') !== f.align) { ab.innerHTML = ALIGN_ICON[f.align]; ab.setAttribute('data-cur', f.align); }
        lgRoot.querySelectorAll('[data-act=undo]').forEach(function (b) { b.disabled = !DW.history.canUndo(); });
        lgRoot.querySelectorAll('[data-act=redo]').forEach(function (b) { b.disabled = !DW.history.canRedo(); });
        $('dwTableOps').hidden = !f.inTable;
        var more = $('dwPopMore');
        var cf = more.querySelector('[data-cur=font]'); if (cf) cf.textContent = fo ? fo.name : '';
        var cs = more.querySelector('[data-cur=size]'); if (cs) cs.textContent = f.size + ' pt';
        var r = DW.sel.range();
        var hasSel = !!(r && !r.collapsed && r.toString().trim());
        $('dwAiBtn').classList.toggle('on', hasSel && !!C.ai.enabled);
        bubble(hasSel, r);
        syncStatus();
    });
}
DW.on('selection', syncToolbar);
DW.on('history', syncToolbar);

/* ── кегль: поле ───────────────────────────────────────────────────────── */
(function () {
    var sz = $('dwSize');
    function applyTyped() {
        var v = parseFloat(String(sz.value).replace(',', '.'));
        if (v > 0 && v <= 400) DW.cmd.size(v);
        else syncToolbar();
    }
    sz.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); applyTyped(); closePops(); }
        else if (e.key === 'Escape') { syncToolbar(); DW.sel.restore(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); DW.cmd.stepSize(1); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); DW.cmd.stepSize(-1); }
    });
    sz.addEventListener('focus', function () { sz.select(); openPop('dwPopSize', sz); });
    sz.addEventListener('change', applyTyped);
})();

/* ── цвета ─────────────────────────────────────────────────────────────── */
function setColor(c) {
    DW.cmd.color(c);
    $('dwColorI').style.setProperty('--dw-c', c || '#000');
    prefs.save(SLUG, 'color', c || '');
}
function setMark(c) {
    DW.cmd.mark(c);
    if (c) { $('dwMarkI').style.setProperty('--dw-c', c); prefs.save(SLUG, 'mark', c); }
}
$('dwColorPick').addEventListener('change', function (e) { setColor(e.target.value); closePops(); });
// Нажатие на сам значок (не на стрелку) — последний цвет, как в Word.
(function () {
    var c = prefs.load(SLUG, 'color', ''), m = prefs.load(SLUG, 'mark', '#fff3a3');
    $('dwColorI').style.setProperty('--dw-c', c || '#000');
    $('dwMarkI').style.setProperty('--dw-c', m);
})();

/* ── интервалы (на весь документ) ──────────────────────────────────────── */
function syncSpacing() {
    var p = $('dwPopSpacing');
    p.querySelectorAll('[data-act=lh]').forEach(function (b) { b.setAttribute('aria-pressed', Math.abs(parseFloat(b.getAttribute('data-v')) - S.set.lh) < 0.01 ? 'true' : 'false'); });
    p.querySelectorAll('[data-act=pafter]').forEach(function (b) { b.setAttribute('aria-pressed', Math.abs(parseFloat(b.getAttribute('data-v')) - S.set.pafter) < 0.01 ? 'true' : 'false'); });
    p.querySelectorAll('[data-act=findent]').forEach(function (b) { b.setAttribute('aria-pressed', Math.abs(parseFloat(b.getAttribute('data-v')) - S.set.findent) < 0.01 ? 'true' : 'false'); });
}

/* ── таблица: сетка выбора и операции ──────────────────────────────────── */
(function () {
    var g = $('dwTGrid'), l = $('dwTGridL'), h = '';
    for (var r = 1; r <= 8; r++) for (var c = 1; c <= 8; c++) h += '<button type="button" data-r="' + r + '" data-c="' + c + '" aria-label="' + r + ' × ' + c + '"></button>';
    g.innerHTML = h;
    function hi(r, c) {
        g.querySelectorAll('button').forEach(function (b) { b.classList.toggle('on', +b.getAttribute('data-r') <= r && +b.getAttribute('data-c') <= c); });
        l.textContent = r + ' × ' + c;
    }
    g.addEventListener('pointerover', function (e) { var b = e.target.closest('button'); if (b) hi(+b.getAttribute('data-r'), +b.getAttribute('data-c')); });
    g.addEventListener('focusin', function (e) { var b = e.target.closest('button'); if (b) hi(+b.getAttribute('data-r'), +b.getAttribute('data-c')); });
    g.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        closePops();
        DW.cmd.table(+b.getAttribute('data-r'), +b.getAttribute('data-c'));
        DW.track('table_insert', { r: +b.getAttribute('data-r'), c: +b.getAttribute('data-c') });
    });
})();
function tableOp(a) {
    var r = DW.sel.restore(); if (!r) return;
    var n = r.startContainer.nodeType === 1 ? r.startContainer : r.startContainer.parentNode;
    var cell = n.closest('td,th'); if (!cell || !doc.contains(cell)) return;
    var row = cell.parentNode, table = cell.closest('table'), ci = cell.cellIndex;
    DW.cmd.run(function () {
        var rows = Array.prototype.slice.call(table.rows);
        function blankCell(tag) { var c = document.createElement(tag || 'td'); c.innerHTML = '<br>'; return c; }
        if (a === 'row-above' || a === 'row-below') {
            var nr = document.createElement('tr');
            for (var i = 0; i < row.cells.length; i++) nr.appendChild(blankCell());
            row.parentNode.insertBefore(nr, a === 'row-above' ? row : row.nextSibling);
        } else if (a === 'col-left' || a === 'col-right') {
            rows.forEach(function (tr) {
                var ref = tr.cells[Math.min(ci, tr.cells.length - 1)];
                var c = blankCell(ref && ref.tagName === 'TH' ? 'th' : 'td');
                tr.insertBefore(c, a === 'col-left' ? ref : (ref ? ref.nextSibling : null));
            });
        } else if (a === 'row-del') {
            if (rows.length <= 1) { removeTable(table); return; }
            row.parentNode.removeChild(row);
        } else if (a === 'col-del') {
            if (row.cells.length <= 1) { removeTable(table); return; }
            rows.forEach(function (tr) { if (tr.cells[ci]) tr.removeChild(tr.cells[ci]); });
        } else if (a === 'head-toggle') {
            var first = rows[0];
            var toTh = first.cells[0] && first.cells[0].tagName !== 'TH';
            Array.prototype.slice.call(first.cells).forEach(function (c) {
                var nc = document.createElement(toTh ? 'th' : 'td');
                while (c.firstChild) nc.appendChild(c.firstChild);
                if (c.colSpan > 1) nc.colSpan = c.colSpan;
                first.replaceChild(nc, c);
            });
        } else if (a === 'table-del') removeTable(table);
    }, 'table_' + a);
    function removeTable(tb) {
        var p = document.createElement('p'); p.innerHTML = '<br>';
        tb.parentNode.replaceChild(p, tb);
        var s = window.getSelection(), nr = document.createRange(); nr.setStart(p, 0); nr.collapse(true); s.removeAllRanges(); s.addRange(nr);
    }
}

/* ── символы ───────────────────────────────────────────────────────────── */
var SYM = {
    common: '«»„“”‘’—–…№§©®™°±×÷€₽$£¥•·†‡¶‰′″¹²³½¼¾',
    math: '∞≈≠≡≤≥±√∑∏∫∂∆∇∈∉⊂⊃∪∩∧∨¬∀∃∅∝∠⊥∥πµΩ',
    arrows: '←→↑↓↔↕⇐⇒⇑⇓⇔↗↘↙↖➜✓✔✗✘☐☑★☆',
    greek: 'αβγδεζηθικλμνξοπρστυφχψωΑΒΓΔΕΘΛΞΠΣΦΨΩ',
    currency: '₽$€£¥₹₩₺₴₸₼₾¢₿'
};
(function () {
    var tabs = $('dwSymTabs'), grid = $('dwSymGrid');
    var names = { common: t('sym_common'), math: t('sym_math'), arrows: t('sym_arrows'), greek: t('sym_greek'), currency: t('sym_currency') };
    var recent = prefs.load(SLUG, 'symrecent', '');
    function render(cat) {
        var chars = cat === 'recent' ? recent : SYM[cat];
        grid.innerHTML = Array.from(chars || '').map(function (c) { return '<button type="button" data-ch="' + esc(c) + '" aria-label="' + esc(c) + '">' + esc(c) + '</button>'; }).join('');
        tabs.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cat') === cat ? 'true' : 'false'); });
    }
    var th = '';
    if (recent) th += '<button type="button" data-cat="recent" data-pop-keep>' + esc(t('sym_recent')) + '</button>';
    for (var k in SYM) th += '<button type="button" data-cat="' + k + '" data-pop-keep>' + esc(names[k]) + '</button>';
    tabs.innerHTML = th;
    tabs.addEventListener('click', function (e) { var b = e.target.closest('[data-cat]'); if (b) render(b.getAttribute('data-cat')); });
    grid.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ch]'); if (!b) return;
        var ch = b.getAttribute('data-ch');
        DW.cmd.text(ch);
        recent = (ch + recent.replace(ch, '')).slice(0, 16);
        prefs.save(SLUG, 'symrecent', recent);
    });
    render(recent ? 'recent' : 'common');
})();

/* ── ссылка ────────────────────────────────────────────────────────────── */
var linkTarget = null;
function openLink(src) {
    var f = DW.currentFormat();
    var r = DW.sel.restore();
    linkTarget = f.link;
    $('dwLinkUrl').value = f.link ? f.link.getAttribute('href') || '' : '';
    $('dwLinkText').value = f.link ? f.link.textContent : (r ? r.toString() : '');
    $('dwLinkDel').hidden = !f.link;
    var anchor = src && src.closest && src.closest('.dw-bubble,.dw-bar,#dwPopMore') ? src : (bar.querySelector('[data-act=link]:not([data-over=true] *)') || bar.querySelector('#dwMoreBtn'));
    openPop('dwPopLink', anchor.offsetParent ? anchor : $('dwMoreBtn'));
    setTimeout(function () { try { $('dwLinkUrl').focus({ preventScroll: true }); } catch (e) {} }, 30);
}
function applyLink() {
    var url = $('dwLinkUrl').value.trim(), text = $('dwLinkText').value;
    closePops();
    if (!url) return;
    if (!/^(https?:|mailto:|tel:|#)/i.test(url)) url = (/^[^\s@]+@[^\s@]+$/.test(url) ? 'mailto:' : 'https://') + url;
    DW.cmd.run(function () {
        if (linkTarget && doc.contains(linkTarget)) {
            linkTarget.setAttribute('href', url);
            if (text && text !== linkTarget.textContent) linkTarget.textContent = text;
            return;
        }
        var r = DW.sel.restore();
        var a = document.createElement('a');
        a.setAttribute('href', url);
        if (r && !r.collapsed && (!text || text === r.toString())) {
            a.appendChild(r.extractContents());
            r.insertNode(a);
        } else {
            a.textContent = text || url;
            if (r) { r.deleteContents(); r.insertNode(a); }
        }
        var s = window.getSelection(), nr = document.createRange(); nr.setStartAfter(a); nr.collapse(true); s.removeAllRanges(); s.addRange(nr);
    }, 'link');
    DW.track('link', {});
}
$('dwLinkOk').addEventListener('click', applyLink);
[$('dwLinkUrl'), $('dwLinkText')].forEach(function (el) { el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyLink(); } }); });
$('dwLinkDel').addEventListener('click', function () {
    closePops();
    if (!linkTarget || !doc.contains(linkTarget)) return;
    DW.cmd.run(function () {
        var a = linkTarget;
        while (a.firstChild) a.parentNode.insertBefore(a.firstChild, a);
        a.parentNode.removeChild(a);
    }, 'unlink');
});
// Ссылка в документе по Ctrl+щелчку открывается (обычный щелчок ставит каретку).
doc.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (a && (e.ctrlKey || e.metaKey)) { e.preventDefault(); window.open(a.href, '_blank', 'noopener'); }
});

/* ── картинка: щелчок выделяет, плавающая панель даёт размер и выравнивание ─ */
var selImg = null;
doc.addEventListener('click', function (e) {
    var img = e.target.closest('img');
    doc.querySelectorAll('img.dw-sel').forEach(function (x) { if (x !== img) x.classList.remove('dw-sel'); });
    selImg = img || null;
    if (!img) return;
    img.classList.add('dw-sel');
    var s = window.getSelection(), r = document.createRange();
    r.selectNode(img); s.removeAllRanges(); s.addRange(r);
    imageBubble(img);
});
function imageBubble(img) {
    var b = $('dwBubble');
    b.innerHTML = [25, 50, 75, 100].map(function (w) { return '<button type="button" class="dw-b" data-img-w="' + w + '">' + w + '%</button>'; }).join('') +
        '<button type="button" class="dw-b sq" data-img-al="left" aria-label="' + esc(t('al_left')) + '">' + ALIGN_ICON.left + '</button>' +
        '<button type="button" class="dw-b sq" data-img-al="center" aria-label="' + esc(t('al_center')) + '">' + ALIGN_ICON.center + '</button>' +
        '<button type="button" class="dw-b sq" data-img-al="right" aria-label="' + esc(t('al_right')) + '">' + ALIGN_ICON.right + '</button>' +
        '<button type="button" class="dw-b" data-img-del>' + esc(t('delete')) + '</button>';
    b.setAttribute('data-mode', 'img');
    placeBubble(img.getBoundingClientRect());
}
$('dwBubble').addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    if (b.hasAttribute('data-img-w') && selImg) {
        var w = b.getAttribute('data-img-w');
        DW.cmd.run(function () { selImg.style.width = w + '%'; selImg.style.height = 'auto'; }, 'img_w');
        imageBubble(selImg);
    } else if (b.hasAttribute('data-img-al') && selImg) {
        var al = b.getAttribute('data-img-al');
        var blk = DW.curBlock(selImg);
        DW.cmd.run(function () { if (blk) blk.style.textAlign = al; }, 'img_al');
        imageBubble(selImg);
    } else if (b.hasAttribute('data-img-del') && selImg) {
        var im = selImg; selImg = null;
        DW.cmd.run(function () { im.parentNode.removeChild(im); }, 'img_del');
        hideBubble();
    }
});

/* ── плавающая панель над выделением (касание) ─────────────────────────── */
var BUBBLE_TEXT = $('dwBubble').innerHTML;
var touchSel = false;
doc.addEventListener('pointerup', function (e) { touchSel = e.pointerType === 'touch' || e.pointerType === 'pen'; if (touchSel) setTimeout(syncToolbar, 30); });
doc.addEventListener('keydown', function () { touchSel = false; });
function bubble(hasSel, r) {
    var b = $('dwBubble');
    if (b.getAttribute('data-mode') === 'img') { if (!selImg || !doc.contains(selImg)) hideBubble(); return; }
    // только после выделения пальцем: выделение из кода (поле шаблона, поиск)
    // панель не вызывает
    if (!hasSel || !touchSel) { hideBubble(); return; }
    if (b.getAttribute('data-mode') !== 'text') { b.innerHTML = BUBBLE_TEXT; b.setAttribute('data-mode', 'text'); }
    placeBubble(r.getBoundingClientRect());
}
function placeBubble(rect) {
    var b = $('dwBubble');
    b.setAttribute('data-show', 'true');
    var pr = paper.getBoundingClientRect();
    var z = S.view === 'page' ? (pr.width / (paper.offsetWidth || pr.width)) || 1 : 1;
    var bw = b.offsetWidth, bh = b.offsetHeight;
    var x = (rect.left + rect.width / 2 - pr.left) / z - bw / 2;
    var y = (rect.top - pr.top) / z - bh - 10;
    if (y < 4) y = (rect.bottom - pr.top) / z + 10;
    x = Math.max(4, Math.min(x, paper.offsetWidth - bw - 4));
    b.style.left = x + 'px'; b.style.top = y + 'px';
}
function hideBubble() {
    var b = $('dwBubble');
    b.setAttribute('data-show', 'false');
    if (b.getAttribute('data-mode') === 'img') { b.innerHTML = BUBBLE_TEXT; b.setAttribute('data-mode', 'text'); }
}

/* ── оглавление ────────────────────────────────────────────────────────── */
function headings() {
    return Array.prototype.slice.call(doc.querySelectorAll('h1,h2,h3')).filter(function (h) { return h.textContent.trim(); });
}
function insertToc() {
    var hs = headings();
    if (!hs.length) { DW.toast(t('toc_empty'), 'info'); return; }
    var existing = doc.querySelector('.dw-toc');
    var pages = DW.paginate && DW.paginate.planNow ? pageOfHeadings(hs) : {};
    var h = '<div class="dw-toc" data-dw-toc="1"><p style="text-align:center"><b>' + esc(t('toc_title')) + '</b></p>';
    hs.forEach(function (x, i) {
        var lvl = +x.tagName.charAt(1);
        var pg = pages[i] ? pages[i] : '';
        h += '<p style="margin-inline-start:' + ((lvl - 1) * 1.25) + 'cm;text-align:justify;text-align-last:justify">' + esc(x.textContent.trim()) + (pg ? ' <span>' + pg + '</span>' : '') + '</p>';
    });
    h += '</div>';
    DW.cmd.run(function () {
        if (existing) { var tmp = document.createElement('div'); tmp.innerHTML = h; existing.parentNode.replaceChild(tmp.firstChild, existing); }
        else DW.cmd.insertBlocks(h);
    }, 'toc');
    DW.track('toc', { n: hs.length });
    DW.toast(existing ? t('toc_updated') : t('toc_done'), 'success');
}
function pageOfHeadings(hs) {
    var pl = DW.paginate.planNow(); if (!pl) return {};
    var top0 = doc.getBoundingClientRect().top, z = S.zoom || 1, out = {};
    hs.forEach(function (h, i) {
        var y = (h.getBoundingClientRect().top - top0) / (doc.getBoundingClientRect().width / DW.pageSizePx().w || 1);
        out[i] = Math.floor(y / pl.slot) + 1;
    });
    void z;
    return out;
}

/* ── структура (по заголовкам) ─────────────────────────────────────────── */
function toggleOutline(force) {
    var side = $('dwSide');
    var show = force == null ? side.hidden : force;
    side.hidden = !show;
    S.outline = show;
    prefs.save(SLUG, 'outline', show);
    if (show) renderOutline();
    DW.track('outline', { on: show ? 1 : 0 });
}
var olTimer = 0;
function renderOutline() {
    if ($('dwSide').hidden) return;
    var hs = headings(), host = $('dwOutline');
    if (!hs.length) { host.innerHTML = '<p class="dw-side-empty">' + esc(t('outline_empty')) + '</p>'; return; }
    host.innerHTML = hs.map(function (h, i) {
        return '<button type="button" class="dw-ol-i" data-l="' + h.tagName.charAt(1) + '" data-i="' + i + '">' + esc(h.textContent.trim().slice(0, 140)) + '</button>';
    }).join('');
    markOutline();
}
function markOutline() {
    if ($('dwSide').hidden) return;
    var b = DW.curBlock(); if (!b) return;
    var hs = headings(), cur = -1;
    for (var i = 0; i < hs.length; i++) {
        if (hs[i] === b || (hs[i].compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING)) cur = i; else break;
    }
    $('dwOutline').querySelectorAll('.dw-ol-i').forEach(function (x) { x.setAttribute('aria-current', +x.getAttribute('data-i') === cur ? 'true' : 'false'); });
}
$('dwOutline').addEventListener('click', function (e) {
    var b = e.target.closest('.dw-ol-i'); if (!b) return;
    var h = headings()[+b.getAttribute('data-i')]; if (!h) return;
    var s = window.getSelection(), r = document.createRange();
    r.selectNodeContents(h); r.collapse(true);
    try { doc.focus({ preventScroll: true }); } catch (er) {}
    s.removeAllRanges(); s.addRange(r);
    var cr = canvas.getBoundingClientRect(), hr = h.getBoundingClientRect();
    canvas.scrollTop += hr.top - cr.top - 24;
    if (root.offsetWidth < 900) toggleOutline(false);
});
$('dwSideX').addEventListener('click', function () { toggleOutline(false); });
DW.on('change', function () { clearTimeout(olTimer); olTimer = setTimeout(renderOutline, 400); });
DW.on('selection', markOutline);

/* ── поиск и замена ────────────────────────────────────────────────────── */
var F = { ranges: [], cur: -1, cs: false, word: false };
var HL = !!(window.CSS && CSS.highlights && window.Highlight);
function openFind() {
    var f = $('dwFind');
    f.hidden = false;
    var r = DW.sel.range();
    var q = $('dwFindQ');
    if (r && !r.collapsed && r.toString().length < 80) q.value = r.toString();
    q.focus({ preventScroll: true }); q.select();
    runFind();
    DW.track('find_open', {});
}
function closeFind() {
    $('dwFind').hidden = true;
    var cur = F.ranges[F.cur];
    clearHl();
    if (cur) { var s = window.getSelection(); try { doc.focus({ preventScroll: true }); } catch (e) {} s.removeAllRanges(); s.addRange(cur); }
    else DW.sel.restore();
    F.ranges = []; F.cur = -1;
}
function clearHl() { if (HL) { CSS.highlights.delete('dw-find'); CSS.highlights.delete('dw-find-cur'); } }
function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
function findRanges(q) {
    var out = [];
    if (!q) return out;
    var re = new RegExp((F.word ? '(^|[^\\p{L}\\p{N}_])(' + escRe(q) + ')(?=$|[^\\p{L}\\p{N}_])' : '()(' + escRe(q) + ')'), F.cs ? 'gu' : 'giu');
    var w = document.createTreeWalker(doc, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
        var v = n.nodeValue, m;
        re.lastIndex = 0;
        while ((m = re.exec(v))) {
            var s = m.index + m[1].length;
            var r = document.createRange();
            r.setStart(n, s); r.setEnd(n, s + m[2].length);
            out.push(r);
            if (m[0].length === 0) re.lastIndex++;
        }
    }
    return out;
}
function runFind(keepIdx) {
    var q = $('dwFindQ').value;
    F.ranges = findRanges(q);
    if (!keepIdx || F.cur >= F.ranges.length) {
        // ближайшее совпадение от каретки
        var r = DW.sel.last(), idx = 0;
        if (r) for (var i = 0; i < F.ranges.length; i++) { if (F.ranges[i].compareBoundaryPoints(Range.START_TO_START, r) >= 0) { idx = i; break; } }
        F.cur = F.ranges.length ? idx : -1;
    }
    paintFind();
}
function paintFind() {
    var n = F.ranges.length;
    $('dwFindN').textContent = $('dwFindQ').value ? (n ? t('find_count', { i: F.cur + 1, n: n }) : t('find_none')) : '';
    if (HL) {
        clearHl();
        if (n) {
            CSS.highlights.set('dw-find', new Highlight(...F.ranges));
            if (F.ranges[F.cur]) CSS.highlights.set('dw-find-cur', new Highlight(F.ranges[F.cur]));
        }
    }
    if (F.ranges[F.cur]) reveal(F.ranges[F.cur]);
}
function stepFind(d) {
    if (!F.ranges.length) return;
    F.cur = (F.cur + d + F.ranges.length) % F.ranges.length;
    paintFind();
    if (!HL) { var s = window.getSelection(); s.removeAllRanges(); s.addRange(F.ranges[F.cur]); }
}
$('dwFindQ').addEventListener('input', function () { runFind(); });
$('dwFindQ').addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); stepFind(e.shiftKey ? -1 : 1); }
    else if (e.key === 'Escape') { e.preventDefault(); closeFind(); }
});
$('dwFindR').addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); replaceOne(); }
    else if (e.key === 'Escape') { e.preventDefault(); closeFind(); }
});
$('dwFindNext').addEventListener('click', function () { stepFind(1); });
$('dwFindPrev').addEventListener('click', function () { stepFind(-1); });
$('dwFindX').addEventListener('click', closeFind);
$('dwFindCase').addEventListener('click', function () { F.cs = !F.cs; this.setAttribute('aria-pressed', F.cs ? 'true' : 'false'); runFind(); });
$('dwFindWord').addEventListener('click', function () { F.word = !F.word; this.setAttribute('aria-pressed', F.word ? 'true' : 'false'); runFind(); });
function replaceOne() {
    var r = F.ranges[F.cur]; if (!r) return;
    var rep = $('dwFindR').value;
    var s = window.getSelection();
    DW.cmd.run(function () {
        s.removeAllRanges(); s.addRange(r);
        r.deleteContents();
        if (rep) r.insertNode(document.createTextNode(rep));
        doc.normalize();
    }, 'replace');
    runFind(true);
    try { $('dwFindR').focus({ preventScroll: true }); } catch (e) {}
}
function replaceAll() {
    var rep = $('dwFindR').value;
    var list = findRanges($('dwFindQ').value);
    if (!list.length) return;
    DW.cmd.run(function () {
        for (var i = list.length - 1; i >= 0; i--) {
            list[i].deleteContents();
            if (rep) list[i].insertNode(document.createTextNode(rep));
        }
        doc.normalize();
    }, 'replace_all');
    DW.toast(t('replaced_n', { n: list.length }), 'success', undoToastOpts());
    DW.track('replace_all', { n: list.length });
    runFind();
}
$('dwFindOne').addEventListener('click', replaceOne);
$('dwFindAll').addEventListener('click', replaceAll);
DW.on('change', function () { if (!$('dwFind').hidden) { clearTimeout(F.t); F.t = setTimeout(function () { runFind(true); }, 250); } });

/* Поля шаблона [в скобках] — подсветка без изменения текста. */
var fieldTimer = 0;
function paintFields() {
    if (!HL || !DW.fields) return;
    var f = DW.fields();
    if (f.length) CSS.highlights.set('dw-field', new Highlight(...f)); else CSS.highlights.delete('dw-field');
}
DW.on('change', function () { clearTimeout(fieldTimer); fieldTimer = setTimeout(paintFields, 200); });

/* ── статистика ────────────────────────────────────────────────────────── */
function openStats() {
    renderStats();
    var g = S.set.goal || {};
    $('dwGoal').value = g.n || '';
    $('dwGoalUnit').value = g.unit || (C.gost ? 'chars_ns' : 'words');
    renderGoal();
    dlg('dwDlgStats');
    DW.track('stats_open', {});
}
function renderStats() {
    var r = DW.sel.range();
    var selTxt = r && !r.collapsed ? r.toString() : '';
    var st = DW.textStats(), N = DW.fmtNum;
    var pages = DW.paginate ? DW.paginate.pages() : 1;
    var cells = [
        [t('st_words'), N(st.words)], [t('st_chars'), N(st.chars)], [t('st_chars_ns'), N(st.charsNs)],
        [t('st_paras'), N(st.paras)], [t('st_sentences'), N(st.sentences)], [t('st_pages'), N(pages)],
        [t('st_read'), t('min_n', { n: st.readMin })], [t('st_speak'), t('min_n', { n: st.speakMin })]
    ];
    if (selTxt) { var ss = DW.textStats(selTxt); cells.push([t('st_selection'), t('sel_words', { n: N(ss.words), c: N(ss.chars) })]); }
    $('dwStatsGrid').innerHTML = cells.map(function (c) { return '<div class="dw-st"><div class="dw-st-l">' + esc(c[0]) + '</div><div class="dw-st-v">' + esc(c[1]) + '</div></div>'; }).join('');
}
function renderGoal() {
    var n = parseInt($('dwGoal').value, 10) || 0, unit = $('dwGoalUnit').value;
    var st = DW.textStats();
    var have = unit === 'words' ? st.words : unit === 'chars' ? st.chars : st.charsNs;
    $('dwGoalBar').style.width = n ? Math.min(100, have / n * 100).toFixed(1) + '%' : '0';
    $('dwGoalTxt').textContent = n ? t('goal_left', { have: DW.fmtNum(have), n: DW.fmtNum(n), left: DW.fmtNum(Math.max(0, n - have)) }) : t('goal_hint');
}
function saveGoal() {
    var n = parseInt($('dwGoal').value, 10) || 0;
    S.set.goal = n ? { n: n, unit: $('dwGoalUnit').value } : null;
    renderGoal();
    syncStatus();
    if (DW.drafts) DW.drafts.touch(false);
}
$('dwGoal').addEventListener('input', saveGoal);
$('dwGoalUnit').addEventListener('change', saveGoal);

/* ── строка состояния ──────────────────────────────────────────────────── */
var statTimer = 0;
function syncStatus() {
    clearTimeout(statTimer);
    statTimer = setTimeout(function () {
        var st = DW.textStats(), N = DW.fmtNum;
        var pages = DW.paginate ? DW.paginate.pages() : 1, cur = DW.paginate ? DW.paginate.current() : 1;
        var parts = [], xs = root.offsetWidth < 420;
        if (S.view === 'page') parts.push('<b>' + esc(t('page_of', { i: cur, n: pages })) + '</b>');
        else if (!xs) parts.push(esc(t('pages_approx', { n: pages })));
        parts.push(esc(t('words_n', { n: N(st.words) })));
        if (!xs) parts.push(esc(t('chars_n', { n: N(st.chars) })));
        var r = DW.sel.range();
        if (r && !r.collapsed) {
            var sw = DW.countWords(r.toString());
            if (sw) parts.push(esc(t('sel_n', { n: N(sw) })));
        }
        var g = S.set.goal;
        if (g && g.n) {
            var have = g.unit === 'words' ? st.words : g.unit === 'chars' ? st.chars : st.charsNs;
            if (!xs) parts.push(esc(t('goal_pct', { p: Math.min(100, Math.round(have / g.n * 100)) })));
        }
        $('dwStat').innerHTML = parts.join(' · ');
        if ($('dwDlgStats').open) { renderStats(); renderGoal(); }
    }, 120);
}
$('dwStat').addEventListener('click', openStats);
DW.on('change', syncStatus);
DW.on('pages', syncStatus);
DW.on('curpage', syncStatus);

/* ── горячие клавиши ───────────────────────────────────────────────────── */
function openKeys() {
    var mac = /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);
    var M = mac ? '⌘' : (C.locale === 'de' ? 'Strg' : 'Ctrl');
    var rows = [
        ['h', t('keys_text')], [M + '+B', t('bold')], [M + '+I', t('italic')], [M + '+U', t('underline')], [M + '+Shift+X', t('strike')],
        [M + '+[ / ]', t('size_down') + ' / ' + t('size_up')], [M + '+\\', t('clear_format')], [M + '+K', t('link')],
        ['h', t('keys_para')], [M + '+1 / 2 / 3', t('st_h1') + ' / 2 / 3'], [M + '+0', t('st_p')], [M + '+L / E / R / J', t('align')],
        ['Tab / Shift+Tab', t('keys_tab')], ['# ␣', t('st_h1')], ['- ␣', t('list_bullet')], ['1. ␣', t('list_number')], ['> ␣', t('st_quote')],
        ['h', t('keys_doc')], [M + '+Z', t('undo')], [M + '+Shift+Z / ' + M + '+Y', t('redo')], [M + '+Enter', t('page_break')],
        [M + '+F', t('find')], [M + '+S', t('save_as')], [M + '+P', t('print')], [M + '+O', t('open_file')], [M + '+Shift+V', t('paste_plain')]
    ];
    $('dwKeys').innerHTML = rows.map(function (r) {
        return r[0] === 'h' ? '<h5>' + esc(r[1]) + '</h5>' : '<span>' + esc(r[1]) + '</span><kbd>' + esc(r[0]) + '</kbd>';
    }).join('');
    dlg('dwDlgKeys');
}

/* ── вид, масштаб, фокус ───────────────────────────────────────────────── */
function fitZoom() {
    var w = canvas.clientWidth - 32, pw = DW.pageSizePx().w;
    return Math.max(0.3, Math.min(1, w / pw));
}
var zoomMode = (window.CSS && CSS.supports && CSS.supports('zoom', '2')) ? 'zoom' : 'transform';
root.setAttribute('data-zoom-mode', zoomMode);
function setZoom(z, mode) {
    S.zoom = z; S.zoomMode = mode || S.zoomMode;
    paper.style.setProperty('--dw-zoom', String(z));
    $('dwZoomV').textContent = Math.round(z * 100) + '%';
    if (zoomMode === 'transform') {
        // без CSS zoom: высоту под масштаб держим сами, иначе прокрутка врёт
        paper.style.height = (doc.offsetHeight * z) + 'px';
        paper.style.marginBottom = '0';
    }
    prefs.save(SLUG, 'zoom', { z: z, m: S.zoomMode });
    DW.emit('zoom', z);
}
function setView(v, manual) {
    S.view = v;
    root.setAttribute('data-view', v);
    $('dwViewPage').setAttribute('aria-pressed', v === 'page' ? 'true' : 'false');
    $('dwViewFlow').setAttribute('aria-pressed', v === 'flow' ? 'true' : 'false');
    DW.applySettings(true);
    if (v === 'page' && S.zoomMode === 'fit') setZoom(fitZoom(), 'fit');
    if (manual) { prefs.save(SLUG, 'view', v); DW.track('view', { v: v }); }
    DW.emit('view', v);
    syncStatus();
}
$('dwViewPage').addEventListener('click', function () { setView('page', true); });
$('dwViewFlow').addEventListener('click', function () { setView('flow', true); });
var lastW = 0;
function onResize() {
    var w = root.offsetWidth;
    /* Нулевая коробка — не «узкий экран». ResizeObserver присылает 0×0, когда
       корень ушёл из документа или спрятан (display:none). Sentry PK: страницу
       переписали снаружи через 4 с после набора — замер 0 переключал вид на
       «Текстом» и падал на кнопках вида, которых в документе уже нет; у
       спрятанного корня он же сбрасывал вид и масштаб впустую. Решать по
       такому замеру нечего: вернётся коробка — придёт и новый замер. */
    if (!w) return;
    root.setAttribute('data-narrow', w < 680 ? 'true' : 'false');
    if (Math.abs(w - lastW) < 2) return;
    lastW = w;
    var savedView = prefs.load(SLUG, 'view', null);
    var fz = fitZoom();
    if (!savedView) {
        // На узком экране страница целиком читалась бы мельче 7 pt — пишем «Текстом».
        var want = fz < 0.62 ? 'flow' : 'page';
        if (want !== S.view) setView(want, false);
    }
    if (S.view === 'page' && S.zoomMode === 'fit') setZoom(fz, 'fit');
}
var roRoot = window.ResizeObserver ? new ResizeObserver(function () { requestAnimationFrame(onResize); }) : null;
if (roRoot) roRoot.observe(root); else window.addEventListener('resize', onResize);

function setFocus(on) {
    S.focusOn = on;
    var el = root;
    if (on) {
        var p = el.requestFullscreen ? el.requestFullscreen() : null;
        if (p && p.catch) p.catch(function () { root.setAttribute('data-focus', 'true'); });
        else if (!p) root.setAttribute('data-focus', 'true');
        DW.track('focus', {});
    } else {
        if (document.fullscreenElement) { try { document.exitFullscreen(); } catch (e) {} }
        root.setAttribute('data-focus', 'false');
    }
    setTimeout(onResize, 120);
}
document.addEventListener('fullscreenchange', function () {
    if (!document.fullscreenElement && S.focusOn && root.getAttribute('data-focus') !== 'true') { S.focusOn = false; setTimeout(onResize, 80); }
});

function syncChecks() {
    var a = $('dwPopMore').querySelector('[data-act=autotypo]'); if (a) a.setAttribute('aria-checked', S.autoTypo ? 'true' : 'false');
    var d = $('dwPopMore').querySelector('[data-act=dark-paper]'); if (d) d.setAttribute('aria-checked', S.darkPaper ? 'true' : 'false');
}

/* ── параметры страницы ────────────────────────────────────────────────── */
function presetName(id) { return t('preset_' + id); }
(function () {
    var sel = $('dwPreset');
    sel.innerHTML = DW.PRESET_ORDER.map(function (id) { return '<option value="' + id + '">' + esc(presetName(id)) + '</option>'; }).join('') +
        '<option value="custom" hidden>' + esc(t('preset_custom')) + '</option>';
})();
function syncPage() {
    var s = S.set;
    $('dwPreset').value = PRESET_MATCH() || 'custom';
    $('dwPresetNote').textContent = t('preset_d_' + ($('dwPreset').value === 'custom' ? 'custom' : $('dwPreset').value));
    $('dwPaperSize').value = s.paper; $('dwOrient').value = s.orient;
    $('dwMT').value = s.m.t; $('dwMB').value = s.m.b; $('dwML').value = s.m.l; $('dwMR').value = s.m.r;
    $('dwPnum').value = s.pnum; $('dwPnFirst').checked = !!s.pnFirst;
    var lbl = s.paper.toUpperCase().replace('LETTER', 'Letter').replace('LEGAL', 'Legal');
    var p = $('dwPreset').value;
    $('dwPageLbl').textContent = lbl + (p !== 'custom' ? ' · ' + t('preset_short_' + p) : '');
    var pc = $('dwPopMore').querySelector('[data-cur=page]'); if (pc) pc.textContent = $('dwPageLbl').textContent;
    syncSpacing();
}
function PRESET_MATCH() {
    var s = S.set;
    for (var i = 0; i < DW.PRESET_ORDER.length; i++) {
        var id = DW.PRESET_ORDER[i], p = DW.PRESETS[id];
        if (p.font === s.font && p.size === s.size && p.lh === s.lh && p.pafter === s.pafter && p.findent === s.findent &&
            p.m.t === s.m.t && p.m.b === s.m.b && p.m.l === s.m.l && p.m.r === s.m.r && p.pnum === s.pnum) return id;
    }
    return '';
}
$('dwPreset').addEventListener('change', function () {
    var id = this.value; if (!DW.PRESETS[id]) return;
    var keep = { paper: S.set.paper, orient: S.set.orient, goal: S.set.goal };
    DW.cmd.run(function () {
        S.set = DW.presetSettings(id);
        S.set.paper = keep.paper; S.set.orient = keep.orient; S.set.goal = keep.goal;
        DW.applySettings();
    }, 'preset');
    DW.toast(t('preset_applied', { name: presetName(id) }), 'success', undoToastOpts());
    DW.track('preset', { id: id });
});
function pageField(k, el, fn) {
    el.addEventListener('change', function () {
        DW.cmd.run(function () { fn(el); DW.applySettings(); }, 'page_' + k);
    });
}
pageField('paper', $('dwPaperSize'), function (el) { S.set.paper = el.value; });
pageField('orient', $('dwOrient'), function (el) { S.set.orient = el.value; });
['T', 'B', 'L', 'R'].forEach(function (x) {
    pageField('m' + x, $('dwM' + x), function (el) { var v = Math.max(0, Math.min(80, parseFloat(el.value) || 0)); S.set.m[x.toLowerCase()] = v; });
});
pageField('pnum', $('dwPnum'), function (el) { S.set.pnum = el.value; });
pageField('pnfirst', $('dwPnFirst'), function (el) { S.set.pnFirst = el.checked; });
DW.on('settings', function () { syncPage(); if (S.view === 'page' && S.zoomMode === 'fit') setZoom(fitZoom(), 'fit'); });

/* ── файлы ─────────────────────────────────────────────────────────────── */
function title() { return ($('dwTitle').value || '').trim(); }
function fileBase() {
    var t0 = title() || firstLine() || t('untitled');
    var s = window.__outputName && window.__outputName.sanitize ? window.__outputName.sanitize(t0) : t0.replace(/[\\/:*?"<>|\u0000-\u001f]+/g, ' ').trim();
    return (s || 'document').slice(0, 80);
}
function firstLine() {
    var b = doc.querySelector('h1,h2,p');
    var s = b ? b.textContent.trim() : '';
    return s.slice(0, 60);
}
function needIo() { return DW.loadScript(C.urls.io).then(function () { if (!DW.io) throw new Error('io_missing'); }); }
function openPicker() {
    if (window.showOpenFilePicker && window.isSecureContext && !/Android|iPhone|iPad/.test(navigator.userAgent)) {
        window.showOpenFilePicker({
            types: [{ description: t('open_types'), accept: Object.assign({
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
                'text/plain': ['.txt'], 'text/markdown': ['.md', '.markdown'], 'text/html': ['.html', '.htm'],
                'application/vnd.oasis.opendocument.text': ['.odt'], 'application/rtf': ['.rtf']
            }, document.getElementById('officeLaneCfg') ? {
                // office lane on: the old Word family reaches the door (openOld)
                'application/msword': ['.doc', '.dot'], 'application/vnd.ms-works': ['.wps'],
                'application/vnd.wordperfect': ['.wpd'], 'application/vnd.apple.pages': ['.pages']
            } : {}) }],
            multiple: false
        }).then(function (hs) {
            var h = hs[0];
            return h.getFile().then(function (f) { return openFile(f, h); });
        }).catch(function (e) { if (e && e.name !== 'AbortError') $('dwFileOpen').click(); });
        return;
    }
    $('dwFileOpen').click();
}
$('dwFileOpen').addEventListener('change', function () {
    var f = this.files && this.files[0];
    this.value = '';
    if (f) openFile(f, null);
});
$('dwImgIn').addEventListener('change', function () {
    var fs = Array.prototype.slice.call(this.files || []);
    this.value = '';
    fs.reduce(function (p, f) { return p.then(function () { return DW.cmd.image(f); }); }, Promise.resolve());
});
/* ── Старые форматы Word (.doc, .wps, .wpd, .pages): office lane ─────────
 * Браузер их не читает. До 16.10.2026 лист отвечал «откройте в Word и сохраните
 * как .docx» (21 сессия с .doc за 20 дней). Теперь решают байты: DOCX или RTF под
 * именем .doc открываются своими читателями, а настоящий старый файл — дверь
 * офисного лейна в окне: Премиум получает DOCX с нашего сервера (LibreOffice), и
 * он открывается здесь же обычным путём; остальные — что мы делаем, почему это
 * входит в план и как обойтись без нас. Лейн выключен (нет #officeLaneCfg) —
 * прежняя фраза. .odt/.ott читает свой разборщик io.js, двери им не нужно. */
var DW_OLD = { doc: 1, dot: 1, wps: 1, wpd: 1, pages: 1 };
var dwOfficeCtl = null;
function officeLaneLoad() {
    if (!document.getElementById('officeLaneCfg')) return Promise.resolve(null);
    if (window.OfficeLane) return Promise.resolve(window.OfficeLane);
    return new Promise(function (res) {
        var sc = document.createElement('script');
        sc.src = (typeof window.__jsSrc === 'function') ? window.__jsSrc('/js/office-lane.js') : '/js/office-lane.js';
        sc.onload = function () { res(window.OfficeLane || null); };
        sc.onerror = function () { res(null); };
        document.head.appendChild(sc);
    });
}
function renamed(file, ext, type) {
    var base = String(file.name || 'document').replace(/\.[A-Za-z0-9]{1,8}$/, '');
    try { return new File([file], base + '.' + ext, { type: type, lastModified: file.lastModified }); } catch (e) { return file; }
}
/* true — файл взяла дверь (или ответила фразой); false — открывать как обычно. */
function openOld(file, ext, handle) {
    return file.slice(0, 8).arrayBuffer().then(function (ab) {
        var h = new Uint8Array(ab);
        if (h[0] === 0x50 && h[1] === 0x4B && ext === 'doc') { openFileNow(renamed(file, 'docx', ''), handle); return true; }
        if (h[0] === 0x7B && h[1] === 0x5C && h[2] === 0x72 && h[3] === 0x74 && h[4] === 0x66) { openFileNow(renamed(file, 'rtf', 'application/rtf'), handle); return true; }
        return officeLaneLoad().then(function (OL) {
            if (!OL || !OL.available()) { DW.toast(t(ext === 'doc' || ext === 'dot' ? 'open_doc_old' : 'open_failed'), 'warning'); return true; }
            return OL.classify(file).then(function (info) {
                if (info.status !== 'legacy' || info.family !== 'word') { DW.toast(t('open_failed'), 'warning'); return true; }
                var d = dlg('dwDlgOffice'), host = $('dwOfficeHost');
                if (!d || !host) { DW.toast(t('open_doc_old'), 'warning'); return true; }
                if (dwOfficeCtl) { try { dwOfficeCtl.destroy(); } catch (e) {} }
                host.innerHTML = '';
                dwOfficeCtl = OL.door(host, {
                    file: file, info: info, tool: SLUG, mode: 'upgrade', targets: ['docx'],
                    onResult: function (out) {
                        try { d.close(); } catch (e) {}
                        if (dwOfficeCtl) { try { dwOfficeCtl.destroy(); } catch (e) {} dwOfficeCtl = null; }
                        openFileNow(out, null);
                    }
                });
                return true;
            });
        });
    }).catch(function (e) { DW.report(e, 'open_old'); DW.toast(t('open_failed'), 'error'); return true; });
}
function openFile(file, handle) {
    var ext = String(file.name || '').toLowerCase().split('.').pop();
    if (DW_OLD[ext]) return openOld(file, ext, handle);
    return openFileNow(file, handle);
}
function openFileNow(file, handle) {
    stage('open');
    DW.toast(t('opening', { name: file.name }), 'info');
    return needIo().then(function () { return DW.io.open(file); }).then(function (res) {
        if (!res) return;
        var keep = !DW.isEmptyDoc();
        var go = function () {
            DW.loadHtml(res.html, null);
            if (res.settings) { S.set = Object.assign(DW.presetSettings(S.set.preset || DW.DEFAULT_PRESET), res.settings); DW.applySettings(); }
            $('dwTitle').value = res.title || file.name.replace(/\.[^.]+$/, '');
            S.fileHandle = handle && /\.docx$/i.test(file.name) ? handle : null;
            DW.history.reset();
            DW.afterChange('open');
            if (DW.drafts) DW.drafts.touch(true);
            syncSave();
            DW.toast(res.warn ? t('opened_warn', { what: res.warn }) : t('opened'), res.warn ? 'warning' : 'success');
            DW.track('open', { ext: (file.name.split('.').pop() || '').toLowerCase().slice(0, 6), kb: Math.round(file.size / 1024), fsa: handle ? 1 : 0 });
        };
        // Открытие файла поверх начатого документа — начатый остаётся в «Моих документах».
        if (keep && DW.drafts) afterReset(go); else go();
    }).catch(function (e) {
        DW.report(e, 'open');
        DW.toast(t('open_failed'), 'error');
    });
}
DW.ui = { act: act, reveal: reveal, openFile: openFile };

function exportBlob(fmt) {
    if (fmt === 'docx') return DW.loadScript(C.urls.docx).then(function () { return DW.exportDocx(); });
    if (fmt === 'pdf') return DW.loadScript(C.urls.pdf).then(function () { return DW.exportPdf(); });
    return needIo().then(function () { return DW.io.exportText(fmt); });
}
var MIME = {
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', pdf: 'application/pdf',
    txt: 'text/plain', md: 'text/markdown', html: 'text/html'
};
var busy = false;
function download(fmt) {
    if (busy) return;
    if (DW.isEmptyDoc()) { DW.toast(t('empty_doc'), 'info'); return; }
    busy = true;
    stage('export');
    var dl = $('dwDlBtn'); dl.disabled = true;
    var t0 = Date.now();
    var slow = setTimeout(function () { DW.toast(t('exporting'), 'info'); }, 700);
    DW.history.commit();
    exportBlob(fmt).then(function (blob) {
        clearTimeout(slow);
        var name = fileBase() + '.' + fmt;
        var p = window.__downloadFile ? window.__downloadFile(blob, name) : Promise.resolve(false);
        return Promise.resolve(p).then(function (ok) {
            if (ok === false) return;
            if (DW.drafts) DW.drafts.exported();
            try { if (window.__aeToolComplete) window.__aeToolComplete({ format: fmt, kb: Math.round(blob.size / 1024), ms: Date.now() - t0, pages: DW.paginate ? DW.paginate.pages() : 0 }); } catch (e) {}
            S.dirty = false; syncSave();
            DW.toast(t('downloaded', { name: name }), 'success');
        });
    }).catch(function (e) {
        clearTimeout(slow);
        if (window.__handleError) window.__handleError(e, 'dw_export_' + fmt, { say: t('export_failed') });
        else DW.toast(t('export_failed'), 'error');
    }).then(function () { busy = false; dl.disabled = false; });
}
/* Ctrl+S: в Chrome и Edge на компьютере — запись в ТОТ ЖЕ .docx (открытый
   отсюда или выбранный «Сохранить как»), иначе — скачать .docx. */
var FSA = !!(window.showSaveFilePicker && window.isSecureContext && !/Android|iPhone|iPad/.test(navigator.userAgent));
if (FSA) $('dwSaveAs').hidden = false;
if (navigator.canShare && /Android|iPhone|iPad/.test(navigator.userAgent)) $('dwShare').hidden = false;
function saveFile(asNew) {
    if (!FSA) { download('docx'); return; }
    var h = asNew ? null : S.fileHandle;
    var getHandle = h ? Promise.resolve(h) : window.showSaveFilePicker({
        suggestedName: fileBase() + '.docx',
        types: [{ description: 'Word', accept: { [MIME.docx]: ['.docx'] } }]
    });
    getHandle.then(function (handle) {
        return exportBlob('docx').then(function (blob) {
            return handle.createWritable().then(function (w) { return w.write(blob).then(function () { return w.close(); }); }).then(function () {
                if (window.__deliveredToDisk) window.__deliveredToDisk(handle.name, blob, 'save_handle');
                S.fileHandle = handle;
                S.dirty = false;
                syncSave(handle.name);
                if (DW.drafts) DW.drafts.exported();
                DW.toast(t('saved_to', { name: handle.name }), 'success');
                DW.track('save_fsa', { again: h ? 1 : 0 });
                try { if (window.__aeToolComplete) window.__aeToolComplete({ format: 'docx', via: 'fsa' }); } catch (e) {}
            });
        });
    }).catch(function (e) {
        if (e && e.name === 'AbortError') return;
        DW.report(e, 'save_fsa');
        download('docx');
    });
}
function shareFile() {
    exportBlob('docx').then(function (blob) {
        var f = new File([blob], fileBase() + '.docx', { type: MIME.docx });
        if (navigator.canShare && navigator.canShare({ files: [f] })) return navigator.share({ files: [f], title: fileBase() });
        return window.__downloadFile(blob, f.name);
    }).catch(function (e) { if (e && e.name !== 'AbortError') DW.toast(t('export_failed'), 'error'); });
}
function printDoc() {
    if (DW.isEmptyDoc()) { DW.toast(t('empty_doc'), 'info'); return; }
    DW.history.commit();
    DW.track('print', {});
    needIo().then(function () { return DW.io.printHtml(); }).then(function (html) {
        var old = document.getElementById('dwPrintFrame');
        if (old) old.remove();
        var fr = document.createElement('iframe');
        fr.id = 'dwPrintFrame';
        fr.setAttribute('aria-hidden', 'true');
        fr.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden';
        document.body.appendChild(fr);
        var w = fr.contentWindow, d = w.document;
        d.open(); d.write(html); d.close();
        var go = function () {
            try { w.focus(); w.print(); } catch (e) { window.print(); }
            setTimeout(function () { fr.remove(); }, 60000);
        };
        // шрифты и картинки должны успеть встать, иначе печать возьмёт запасной шрифт
        var fontsP = d.fonts && d.fonts.ready ? d.fonts.ready : Promise.resolve();
        var imgs = Array.prototype.slice.call(d.images || []);
        Promise.race([
            Promise.all([fontsP].concat(imgs.map(function (im) { return im.complete ? null : new Promise(function (r) { im.onload = im.onerror = r; }); }))),
            new Promise(function (r) { setTimeout(r, 3000); })
        ]).then(go);
    }).catch(function (e) {
        DW.report(e, 'print');
        window.print();
    });
}
function preview() {
    if (DW.isEmptyDoc()) { DW.toast(t('empty_doc'), 'info'); return; }
    var host = $('dwPv');
    host.innerHTML = '<div class="dw-pv-msg">' + esc(t('preview_building')) + '</div>';
    dlg('dwDlgPv');
    DW.loadScript(C.urls.pdf).then(function () { return DW.previewPdf(host); }).catch(function (e) {
        DW.report(e, 'preview');
        host.innerHTML = '<div class="dw-pv-msg">' + esc(t('export_failed')) + '</div>';
    });
    DW.track('preview', {});
}
$('dwDlBtn').addEventListener('click', function () { download('docx'); });
$('dwTplBtn').addEventListener('click', openTemplates);
$('dwOpenBtn').addEventListener('click', openPicker);
$('dwPrintBtn').addEventListener('click', printDoc);
window.addEventListener('beforeprint', function () { DW.history.commit(); });

/* ── шаблоны ───────────────────────────────────────────────────────────── */
var tplCat = 'all';
function openTemplates() {
    var d = dlg('dwDlgTpl');
    var grid = $('dwTplGrid');
    if (!window.DW_TEMPLATES) grid.innerHTML = '<p class="dw-pv-msg">' + esc(t('loading')) + '</p>';
    DW.loadScript(C.urls.templates).then(function () { renderTemplates(); }).catch(function (e) {
        DW.report(e, 'templates');
        grid.innerHTML = '<p class="dw-pv-msg">' + esc(t('load_failed')) + '</p>';
    });
    DW.track('templates_open', {});
    void d;
}
function renderTemplates() {
    var T = window.DW_TEMPLATES; if (!T) return;
    var cats = [{ id: 'all', name: t('tpl_all') }].concat(T.cats || []);
    $('dwTplCats').innerHTML = cats.map(function (c) { return '<button type="button" data-cat="' + esc(c.id) + '" aria-pressed="' + (c.id === tplCat ? 'true' : 'false') + '">' + esc(c.name) + '</button>'; }).join('');
    var items = (T.items || []).filter(function (it) { return tplCat === 'all' || it.cat === tplCat; });
    $('dwTplGrid').innerHTML = items.map(function (it) {
        return '<button type="button" class="dw-tpl" data-tpl="' + esc(it.id) + '"><span class="dw-tpl-thumb" aria-hidden="true"><div>' + it.html + '</div></span>' +
            '<span class="dw-tpl-nm">' + esc(it.name) + '</span>' + (it.desc ? '<span class="dw-tpl-d">' + esc(it.desc) + '</span>' : '') + '</button>';
    }).join('');
    // миниатюра — настоящий лист, уменьшенный под карточку
    $('dwTplGrid').querySelectorAll('.dw-tpl-thumb').forEach(function (th) {
        var w = th.clientWidth || 150;
        th.firstChild.style.transform = 'scale(' + (w / 794).toFixed(4) + ')';
        th.firstChild.setAttribute('inert', '');
    });
}
$('dwTplCats').addEventListener('click', function (e) {
    var b = e.target.closest('[data-cat]'); if (!b) return;
    tplCat = b.getAttribute('data-cat'); renderTemplates();
});
$('dwTplGrid').addEventListener('click', function (e) {
    var b = e.target.closest('[data-tpl]'); if (!b) return;
    var it = (window.DW_TEMPLATES.items || []).filter(function (x) { return x.id === b.getAttribute('data-tpl'); })[0];
    if (!it) return;
    try { $('dwDlgTpl').close(); } catch (er) {}
    applyTemplate(it);
});
function applyTemplate(it) {
    var go = function () {
        S.set = DW.presetSettings(it.preset || S.set.preset || DW.DEFAULT_PRESET);
        if (it.set) for (var k in it.set) S.set[k] = it.set[k];
        DW.applySettings();
        DW.loadHtml(it.html, null);
        $('dwTitle').value = it.title != null ? it.title : it.name;
        DW.history.reset();
        DW.afterChange('template');
        if (DW.drafts) DW.drafts.touch(true);
        // каретка — в первое поле [в скобках]
        var f = DW.fields ? DW.fields() : [];
        try { doc.focus({ preventScroll: true }); } catch (e) {}
        var s = window.getSelection(); s.removeAllRanges();
        if (f.length) { s.addRange(f[0]); reveal(f[0]); }
        canvas.scrollTop = 0;
        DW.toast(f.length ? t('tpl_loaded_fields') : t('tpl_loaded'), 'success');
        DW.track('template', { id: it.id });
        stage('template');
    };
    if (!DW.isEmptyDoc() && DW.drafts) afterReset(go); else go();
}
/* «Новый документ» с содержимым: контроллер сначала дописывает прежнюю работу
   в список, потом (асинхронно) зовёт fresh() — содержимое ставим ПОСЛЕ этого,
   иначе очистка стёрла бы его. */
function afterReset(fn) {
    S.afterFresh = fn;
    DW.drafts.reset();
}

/* ── ИИ ────────────────────────────────────────────────────────────────── */
function openAi() {
    var r = DW.sel.range() || DW.sel.last();
    if (!C.ai.enabled) { DW.toast(t('ai_off'), 'info'); return; }
    if (!r || r.collapsed || !r.toString().trim()) { DW.toast(t('ai_select_first'), 'info'); return; }
    DW.loadScript(C.urls.ai).then(function () { DW.ai.open(r.cloneRange()); }).catch(function (e) {
        DW.report(e, 'ai_load'); DW.toast(t('load_failed'), 'error');
    });
}

/* ── «Мои документы» и сохранение ──────────────────────────────────────── */
function syncSave(fileName) {
    var el = $('dwSave');
    if (fileName || S.fileHandle) { el.setAttribute('data-state', 'file'); el.title = t('linked_file', { name: fileName || S.fileHandle.name }); }
}
function freshDoc() {
    S.set = DW.presetSettings(DW.DEFAULT_PRESET);
    DW.applySettings();
    doc.innerHTML = '<p><br></p>';
    $('dwTitle').value = '';
    S.fileHandle = null;
    DW.history.reset();
    DW.afterChange('fresh');
    canvas.scrollTop = 0;
    var next = S.afterFresh; S.afterFresh = null;
    if (next) setTimeout(next, 0);   // вне quietly(): правка должна завести новую работу
}
var DKEY = {
    draft_saved: 'saved', draft_save_failed: 'save_failed', draft_no_room: 'no_room', draft_open_elsewhere: 'open_elsewhere',
    draft_forked: 'forked', draft_open_failed: 'open_failed', draft_images_missing: 'files_missing', draft_restored: 'restored',
    draft_lost: 'lost', draft_current: 'current', draft_other_tab: 'other_tab', draft_exported: 'exported',
    draft_not_exported: 'not_exported', draft_untitled: 'untitled', draft_delete: 'delete', drafts_empty: 'empty', confirm_reset: 'confirm_reset',
    drafts_usage: 'usage', drafts_trimmed: 'trimmed', drafts_trimmed_row: 'trimmed_row',
    drafts_budget: 'budget', drafts_budget_unlimited: 'budget_unlimited', drafts_budget_note: 'budget_note',
    drafts_protected_yes: 'protected_yes', drafts_protected_no: 'protected_no'
};
function startDrafts() {
    if (!window.__toolDraft || !window.__toolDraft.editor) return null;
    // Обёртка списка внутри меню: контроллер управляет её `hidden`, а меню —
    // popover. Так «Мои документы» живут в общем меню и не спорят друг с другом.
    var wrap = document.createElement('div');
    wrap.id = 'dwDocsWrap';
    wrap.hidden = true;
    var list = $('dwDocsList');
    list.parentNode.insertBefore(wrap, list);
    wrap.appendChild(list);
    // удаление строки не закрывает меню
    list.addEventListener('pointerdown', function (e) { var d = e.target.closest('[data-del]'); if (d) d.setAttribute('data-pop-keep', ''); }, true);
    var ed = window.__toolDraft.editor({
        slug: SLUG, icon: '📄', cls: 'dw', locale: C.locale, debounceMs: 700, openKey: 'dw-draft-open',
        payload: function () {
            if (!S.ready) return null;
            var snap = DW.snapshotForSave();
            var st = DW.textStats();
            return {
                v: 1,
                state: { html: snap.html, set: S.set, title: title() },
                files: snap.files,
                label: title() || firstLine(),
                meta: { words: st.words, pages: DW.paginate ? DW.paginate.pages() : 1 }
            };
        },
        apply: function (d) {
            var st = d.state || {};
            if (st.set) { S.set = Object.assign(DW.presetSettings(DW.DEFAULT_PRESET), st.set); DW.applySettings(); }
            DW.loadHtml(st.html, d.files || []);
            $('dwTitle').value = st.title || '';
            S.fileHandle = null;
            DW.history.reset();
            DW.afterChange('restore');
            canvas.scrollTop = 0;
            return Promise.resolve([]);
        },
        fresh: freshDoc,
        started: function () { return !DW.isEmptyDoc() || !!title(); },
        t: function (k, fb) {
            var own = L_draft(k);
            if (own) return own;
            var b = DKEY[k], bag = C.drafts || {};
            return (b && bag[b]) || fb;
        },
        toast: function (m, ty) { DW.toast(m, ty); },
        ui: {
            saveState: $('dwSaveT'), note: $('dwNote'), noteText: $('dwNoteText'), noteNew: $('dwNoteNew'),
            noteClose: $('dwNoteX'), listBtn: $('dwDocsBtn'), count: $('dwDocsCount'), pop: wrap, list: list, newBtn: $('dwNewBtn')
        }
    });
    $('dwNoteList').addEventListener('click', function () { $('dwDocsBtn').click(); });
    return ed;
}
function L_draft(k) {
    var map = { draft_restored: 'doc_restored', draft_open_elsewhere: 'doc_open_elsewhere', draft_forked: 'doc_forked', drafts_empty: 'docs_empty', draft_untitled: 'untitled', draft_saved: 'saved_here' };
    var key = map[k];
    return key && DW.L[key] ? DW.L[key] : '';
}
// Состояние точки сохранения — из текста, который ставит контроллер.
(function () {
    var st = $('dwSave'), tx = $('dwSaveT');
    var mo = new MutationObserver(function () {
        if (S.fileHandle) return;
        st.setAttribute('data-state', tx.classList.contains('bad') ? 'bad' : (tx.hidden ? 'dirty' : 'saved'));
    });
    mo.observe(tx, { attributes: true, childList: true, characterData: true, subtree: true });
})();
DW.on('change', function (kind) {
    if (!S.ready) return;
    if (kind !== 'restore' && kind !== 'fresh' && !S.fileHandle) $('dwSave').setAttribute('data-state', 'dirty');
    if (DW.drafts && kind !== 'restore' && kind !== 'fresh') DW.drafts.touch(true);
    if (kind === 'input') { stage('edit'); keepCaretVisible(); }
});
DW.on('settings', function () { if (S.ready && DW.drafts) DW.drafts.touch(true); });
$('dwTitle').addEventListener('input', function () { if (DW.drafts) DW.drafts.touch(true); });
$('dwTitle').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); try { doc.focus({ preventScroll: true }); } catch (er) {} } });

/* Уход со страницы с изменениями, которых нет в файле и не сохранить в
   браузере (нет хранилища) — спросить. С хранилищем работа и так вернётся. */
window.addEventListener('beforeunload', function (e) {
    if (S.dirty && !DW.drafts && !DW.isEmptyDoc()) { e.preventDefault(); e.returnValue = ''; }
});

/* ── старт ─────────────────────────────────────────────────────────────── */
function boot() {
    S.autoTypo = prefs.load(SLUG, 'autotypo', true) !== false;
    S.darkPaper = !!prefs.load(SLUG, 'darkpaper', false);
    root.setAttribute('data-dark-paper', S.darkPaper ? 'true' : 'false');
    var z = prefs.load(SLUG, 'zoom', null);
    S.zoomMode = z && z.m === 'fixed' ? 'fixed' : 'fit';
    var v = prefs.load(SLUG, 'view', null);
    lastW = 0;
    if (v) setView(v, false);
    onResize();
    if (S.zoomMode === 'fixed' && z && z.z) setZoom(z.z, 'fixed');
    syncChecks();
    syncPage();
    if (prefs.load(SLUG, 'outline', false) && root.offsetWidth >= 900) toggleOutline(true);
    DW.normalize();
    DW.history.reset();
    fitBar();
    root.setAttribute('data-ready', 'true');
    S.ready = true;
    DW.drafts = startDrafts();
    var adoptOld = function () {
        // Старое однослотовое автосохранение этого тула (до 2026-10-08, localStorage).
        try {
            var old = prefs.load(SLUG, 'autosave', null);
            if (old && old.pages && old.pages[0] && DW.isEmptyDoc()) {
                DW.loadHtml(old.pages[0], null);
                if (old.title) $('dwTitle').value = old.title;
                DW.history.reset();
                DW.afterChange('restore');
                if (DW.drafts && DW.drafts.adopt) DW.drafts.adopt(2);
                localStorage.removeItem('ts_' + SLUG + '_autosave');
                localStorage.removeItem('ts_' + SLUG + '_versions');
            }
        } catch (e) {}
    };
    var bootP = DW.drafts ? DW.drafts.boot() : null;
    if (bootP && bootP.then) bootP.then(adoptOld, adoptOld); else adoptOld();
    DW.fontsReady(4000).then(function () { fitBar(); if (DW.paginate) DW.paginate.now(); });
    if (DW.paginate) DW.paginate.now();
    syncStatus();
    syncToolbar();
    stage('ready');
    // ?template=… — открыть шаблон по ссылке
    var q = /[?&]template=([a-z0-9_-]+)/i.exec(location.search);
    if (q) DW.loadScript(C.urls.templates).then(function () {
        var it = (window.DW_TEMPLATES && window.DW_TEMPLATES.items || []).filter(function (x) { return x.id === q[1]; })[0];
        if (it && DW.isEmptyDoc()) applyTemplate(it);
    }).catch(function () {});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
